import {PAYPAL_PAYMENT_SUCCESS} from '../reducers/types/paymentTypes';
import axios from 'axios';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import jwt from 'jsonwebtoken'
import { trackPromise } from 'react-promise-tracker'

const apiUrl = 'https://pdmsonlinebanfooksoutheast.azurewebsites.net/online-pdms-trustcare/public/api'
const auth = jwt.decode(localStorage.jwtToken)
const apiUrl_backup = 'https://pdmsonlinebanfooksoutheast.azurewebsites.net/online-pdms-trustcare/public/api'



sessionStorage.removeItem('TrustcareGroup' )  
axios.interceptors.response.use(undefined, (err) => {
  const { config, message } = err;
  if (!config || !config.retry) {
  //  return Promise.reject(err);
  }
  // retry while Network timeout or Network Error
  if (!(message.includes("timeout") || message.includes("Network Error"))) {
//    toast.error("err 2")
 //   return Promise.reject(err);
  }
  config.retry -= 1;
  const delayRetryRequest = new Promise((resolve) => {
    setTimeout(() => {
      toast.error("Please wait")
      console.log("retry the request", config.url);
      resolve();
    }, config.retryDelay || 1000);
  });
  return delayRetryRequest.then(() => axios(config));
});


export const paymentSuccess = (data ,order_id) => async dispatch =>{

    var mycount 
    var ok=""

    
    try{
        var shopname = sessionStorage.getItem('shop')  
 
        var encryptedStr = localStorage.getItem('data.orderIDInLocalStorage')
    
    
        var gateway_fee=sessionStorage.getItem('admin_price')  
        var subtotal_price=sessionStorage.getItem('subtotal_price')  
        var total_price=sessionStorage.getItem('QR_price')  
        var username=sessionStorage.getItem('username')  
        var total_count=sessionStorage.getItem('total_count')  
    
        var payment_type=sessionStorage.getItem('payment_type')  
    
        gateway_fee=sessionStorage.getItem('gateway_total')  


        subtotal_price=sessionStorage.getItem('QR_price')  
        total_price=sessionStorage.getItem('QR_price')  
        username=sessionStorage.getItem('username')  
        mycount = 0

        var adminfee_credit_card = sessionStorage.getItem('admin_price')
        var gateway_credit_card = sessionStorage.getItem('gateway_credit_card');

        var res

        var i;

        var test = 'y';

        try {
        for (i = 0; i < 5; i++) {
             toast.success('Server.'+shopname)
              res = await trackPromise(axios.post(`${apiUrl}/paypal-success`, { retry: 3, retryDelay: 3000, data , auth , order_id, gateway_fee, subtotal_price, total_price, username, payment_type, adminfee_credit_card, gateway_credit_card, test}))
              
              if(res.data.message === "testing : ") 
                {
                
                
                    break;
                }    
              
              
              
          }
        } catch (error){}

var total_count1 = res.data.count;       

try {
            //  toast.success('Server...')
              res = await trackPromise(axios.post(`${apiUrl}/paypal-success-temp`, { retry: 3, retryDelay: 3000, data , auth , order_id, gateway_fee, subtotal_price, total_price, username, payment_type, adminfee_credit_card, gateway_credit_card}))
              console.log(res.data, 'suc')
              total_count1 = res.data.count;       
              mycount = mycount + 1 
              
        
        } catch (error){}

        for (i = 0; i < 5; i++) {
            
        }


try {
        for (i = 0; i < 5; i++) {
            //  toast.success('Server...')
              res = await trackPromise(axios.post(`${apiUrl}/paypal-success`, { retry: 3, retryDelay: 3000, data , auth , order_id, gateway_fee, subtotal_price, total_price, username, payment_type, adminfee_credit_card, gateway_credit_card}))
              console.log(res.data, 'suc')
              total_count1 = res.data.count;       
              if(res.data.message === "Payment Successful") break;
              mycount = mycount + 1 
              
          }
        } catch (error){}

        for (i = 0; i < 5; i++) {
          //  toast.success('Server...')
            res = await trackPromise(axios.post(`${apiUrl}/paypal-success`, { retry: 3, retryDelay: 3000, data , auth , order_id, gateway_fee, subtotal_price, total_price, username, payment_type, adminfee_credit_card, gateway_credit_card}))
            console.log(res.data, 'suc')
            total_count1 = res.data.count;       
            if(res.data.message === "Payment Successful") break;
            
              
            
        }


try {
        
      //       toast.success('Server1...')
              res = await trackPromise(axios.post(`${apiUrl}/paypal-success-temp`, {  data , auth , order_id, gateway_fee, subtotal_price, total_price, username, payment_type, adminfee_credit_card, gateway_credit_card}))
            
              console.log(res.data, 'suc')
              total_count1 = res.data.count;       
              
          
        } catch (error){}

        for (i = 0; i < 5; i++) {
      //      toast.success('Server2')
            res = await trackPromise(axios.post(`${apiUrl}/paypal-success`, { retry: 3, retryDelay: 3000, data , auth , order_id, gateway_fee, subtotal_price, total_price, username, payment_type, adminfee_credit_card, gateway_credit_card}))
            
            console.log(res.data, 'suc')
            total_count1 = res.data.count;       
              if(res.data.message === "Payment Successful") break;
              
            
              
            
        }

        
toast.success("total_count-send-"+total_count) 
toast.success("total_count-response-"+total_count1) 

       if (String(total_count1)===String(total_count))  
       { 
        toast.success("match-"+payment_type) 
        if (payment_type==='creditcard')
        {
            window.location.assign('https://online-trustcare.ngrok.io/hitpay/paycard?amount='+total_price+'&ref='+encryptedStr+'&shop='+shopname)
 
        }
        else
        {
            window.location.assign('https://online-trustcare.ngrok.io/hitpay/paynow?amount='+total_price+'&ref='+encryptedStr+'&shop='+shopname)
 
        }
        

       }
        else
        {
                 
        if (payment_type==='creditcard')
        {
            window.location.assign('https://online-trustcare.ngrok.io/hitpay/paycard?amount='+total_price+'&ref='+encryptedStr+'&shop='+shopname)
 
        }
        else
        {
            window.location.assign('https://online-trustcare.ngrok.io/hitpay/paynow?amount='+total_price+'&ref='+encryptedStr+'&shop='+shopname)
 
        }



        }




            if(res.data.message === "Payment Successful"){

                if (payment_type==='creditcard')
                {
                window.location.assign('https://online-trustcare.ngrok.io/hitpay/paycard?amount='+total_price+'&ref='+encryptedStr+'&shop='+shopname)
 
                }
                else
                {   
                window.location.assign('https://online-trustcare.ngrok.io/hitpay/paynow?amount='+total_price+'&ref='+encryptedStr+'&shop='+shopname)
 
                }
       
               

                dispatch({
                    type: PAYPAL_PAYMENT_SUCCESS,
                    payload: res.data
                 });


            }
            else {
                //toast.error(res.data.message)
               toast.success('Payment is processing 2 !')
                dispatch({
                    type: PAYPAL_PAYMENT_SUCCESS,
                    payload: res.data
                 });
            }
       
        } catch (error){

            

           // //toast.error("Internal Server Error");
           toast.success("OK")
    

           try{

             gateway_fee=sessionStorage.getItem('admin_price')  
             subtotal_price=sessionStorage.getItem('subtotal_price')  
            total_price=sessionStorage.getItem('QR_price')  
            username=sessionStorage.getItem('username')  

            gateway_fee=sessionStorage.getItem('admin_price')  
            subtotal_price=sessionStorage.getItem('QR_price')  
            total_price=sessionStorage.getItem('QR_price')  
            username=sessionStorage.getItem('username')  
            mycount = 0
        

            for (i = 0; i < 5; i++) {
                toast.success('Payment Updating .. Now')
                res = await trackPromise(axios.post(`${apiUrl_backup}/paypal-success`, { retry: 3, retryDelay: 3000,data , auth , order_id, gateway_fee, subtotal_price, total_price, username, payment_type, adminfee_credit_card, gateway_credit_card}))
                console.log(res.data, 'suc')
                if(res.data.message === "Payment Successful") break;
                if (mycount > 3) 
                    if(res.data.message !== "Payment Successful") break;
                mycount = mycount + 1 
                
            }
    
    
    
                if(res.data.message === "Payment Successful"){
    
                    toast.success('Payment is processing 3 !!')
                    dispatch({
                        type: PAYPAL_PAYMENT_SUCCESS,
                        payload: res.data
                     });
                }
                else {
                    //toast.error(res.data.message)
                    toast.success('Payment is processing 4 !!')
                    
                    dispatch({
                        type: PAYPAL_PAYMENT_SUCCESS,
                        payload: res.data
                     });
                }
           
            } catch (error){
    
                
    
                toast.success('Payment is processing 5 !!')
                if (payment_type==='creditcard')
                {
                window.location.assign('https://online-trustcare.ngrok.io/hitpay/paycard?amount='+total_price+'&ref='+encryptedStr+'&shop='+shopname)
 
                }
                else
                {
                window.location.assign('https://online-trustcare.ngrok.io/hitpay/paynow?amount='+total_price+'&ref='+encryptedStr+'&shop='+shopname)
 
                }
     
            }
    
    
    
        }

      
    
   
}